export default __webpack_public_path__ + "static/media/pause-button.e6d4244f.svg";